import { useState } from "react";
import PropTypes from "prop-types";
import "./styles.css";
import { NumberFormatValues, NumericFormat } from "react-number-format";
import { useLeadForm } from "../../../context/leadform";

type TextInputProps = {
  label?: string;
  placeholder?: string;
  statekey: string;
  validate?: "email" | "phone" | "true";
  inline?: boolean;
  currency?: boolean;
};

function TextInput({
  label,
  placeholder,
  statekey,
  validate,
  inline,
  currency,
}: TextInputProps) {
  const { responses, updateValue } = useLeadForm();

  const [error, setError] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (validate != null) {
      validateInput(e.target.value);
    }

    updateValue(statekey, e.target.value);
  };

  const onValueChange = (values: NumberFormatValues) => {
    updateValue(statekey, values.value);
  };

  const validateInput = (value: string) => {
    if (validate === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        setError("Please enter a valid email address");
        return false;
      } else {
        setError("");
        return true;
      }
    }
    if (validate == "phone") {
      const phoneRegex = /^\+?[0-9\s\-()]{7,15}$/;
      if (!phoneRegex.test(value)) {
        setError("Please enter a valid phone number");
        return false;
      } else {
        setError("");
        return true;
      }
    }
    if (validate == "true") {
      if (value.trim() === "") {
        setError("This field is required");
        return false;
      } else {
        setError("");
        return true;
      }
    }
  };

  return (
    <div className={`TextInput TextInput_Inline_${inline}`}>
      <label htmlFor={statekey}>{label}</label>
      {currency ? (
        <NumericFormat
          id={statekey}
          name={statekey}
          value={responses[statekey]}
          onValueChange={onValueChange}
          placeholder={placeholder}
          prefix="£"
          thousandSeparator={true}
          allowNegative={false}
          decimalScale={0}
        />
      ) : (
        <input
          type="input"
          id={statekey}
          name={statekey}
          value={responses[statekey]}
          onChange={handleChange}
          placeholder={placeholder}
        />
      )}
      {error !== "" && <small className="error">{error}</small>}
    </div>
  );
}

export default TextInput;
